import "./App.css";
import LiadMusic from "./components/LiadMusic";
import { ThemeProvider } from "./providers/ThemeProvider";
import { LanguageProvider } from "./providers/LanguageProvider";

function App() {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <LiadMusic />
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;
